module.exports = __webpack_public_path__ + "img/sesamia-inferens.d300d949.jpg";